import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { SuiButtonVariant } from '@sensika/sui/button';

@Component({
  selector: 'app-button-cell-renderer',
  templateUrl: './button-cell-renderer.component.html',
  styleUrls: ['./button-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgButtonCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  action: (params) => void;
  title: string;
  leadingIcon: IconProp;
  variant: SuiButtonVariant;
  disabled: boolean;
  iconOnly: boolean;
  ariaLabel: string;

  private resolveParam<T>(value: T | ((params: any) => T), params: any): T {
    return typeof value === 'function'
      ? (value as (params: any) => T)(params)
      : value;
  }

  agInit(params: any): void {
    this.params = params;
    this.action = params.action;
    this.title = this.resolveParam(params.title, params);
    this.leadingIcon = this.resolveParam(params.leadingIcon, params);
    this.variant = this.resolveParam(params.variant, params);
    this.disabled = this.resolveParam(params.disabled ?? false, params);
    this.iconOnly = this.resolveParam(params.iconOnly ?? false, params);
    this.ariaLabel = this.resolveParam(params.ariaLabel, params);
  }

  refresh(params: any): boolean {
    this.params = params;
    this.action = params.action;
    this.title = this.resolveParam(params.title, params);
    this.leadingIcon = this.resolveParam(params.leadingIcon, params);
    this.variant = this.resolveParam(params.variant, params);
    this.disabled = this.resolveParam(params.disabled ?? false, params);
    this.iconOnly = this.resolveParam(params.iconOnly ?? false, params);
    this.ariaLabel = this.resolveParam(params.ariaLabel, params);
    return true;
  }

  /**
   * Handles the click event for the button cell renderer.
   */
  click() {
    if (!this.disabled) {
      this.action(this.params.data); // send the row data to the action
    }
  }
}
